import { TAction } from '../../../../../../shared/frontend/scripts/actions/types/action';
import {
  IGetStatisticsDataQuery,
  TGetTierGearBuSlotQuery,
  TGetTierTalentsQuery,
  TGetTierTrinketsQuery
} from '../../../../../../shared/types/statisticsTypes';
import {
  IRequestState,
  TStatisticChartState,
  TStatisticsState,
  TTierGearState,
  TTierTalentsState,
  TTierTrinketsState
} from '../../libs/store';

const getInitialState = (): TStatisticsState => ({ stats: {}, tierTalents: {}, tierGear: {}, tierTrinkets: {} });

export const DEFAULT_REQUEST_STATE: IRequestState<any> = {
  isLoading: false,
  isLoaded: false,
  error: null,
  data: undefined,
  ui: {}
};

const FETCH_STATISTICS_DATA = 'STATISTICS/FETCH_STATISTICS_DATA';
const FETCH_STATISTICS_DATA_BY_ID = 'STATISTICS/FETCH_STATISTICS_DATA_BY_ID';

const UPDATE_STATISTICS_DATA = 'STATISTICS/UPDATE_STATISTICS_DATA';

const FETCH_TIER_LIST_TALENTS_DATA = 'STATISTICS/FETCH_TIER_LIST_TALENTS_DATA';

const UPDATE_TIER_LIST_TALENTS_DATA = 'STATISTICS/UPDATE_TIER_LIST_TALENTS_DATA';

const FETCH_TIER_GEAR_DATA = 'STATISTICS/FETCH_TIER_GEAR_DATA';

const UPDATE_TIER_GEAR_DATA = 'STATISTICS/UPDATE_TIER_GEAR_DATA';

const FETCH_TIER_TRINKETS_DATA = 'STATISTICS/FETCH_TIER_TRINKETS_DATA';

const UPDATE_TIER_TRINKETS_DATA = 'STATISTICS/UPDATE_TIER_TRINKETS_DATA';

const fetchTierTalentsData = (params: TGetTierTalentsQuery) => ({
  type: FETCH_TIER_LIST_TALENTS_DATA,
  payload: params
});

const updateTierTalentsData = (key: string, data: Partial<TTierTalentsState>) => ({
  type: UPDATE_TIER_LIST_TALENTS_DATA,
  payload: { key, data }
});

const fetchTierGearData = (params: TGetTierGearBuSlotQuery) => ({
  type: FETCH_TIER_GEAR_DATA,
  payload: params
});

const updateTierGearData = (key: string, data: Partial<TTierGearState>) => ({
  type: UPDATE_TIER_GEAR_DATA,
  payload: { key, data }
});

const fetchTierTrinketsData = (params: TGetTierTrinketsQuery) => ({
  type: FETCH_TIER_TRINKETS_DATA,
  payload: params
});

const updateTierTrinketsData = (key: string, data: Partial<TTierTrinketsState>) => ({
  type: UPDATE_TIER_TRINKETS_DATA,
  payload: { key, data }
});

const fetchStatisticsData = (params: IGetStatisticsDataQuery) => ({
  type: FETCH_STATISTICS_DATA,
  payload: params
});

const updateStatisticsData = (key: string, data: Partial<TStatisticChartState>) => ({
  type: UPDATE_STATISTICS_DATA,
  payload: { key, data }
});

const fetchStatisticsDataById = (id: string) => ({
  type: FETCH_STATISTICS_DATA_BY_ID,
  payload: id
});

export function reducer(state = getInitialState(), action: TAction<any>) {
  switch (action.type) {
    case UPDATE_STATISTICS_DATA: {
      const { key, data } = action.payload as { key: string; data: Partial<TStatisticChartState> };
      return {
        ...state,
        stats: {
          ...state.stats,
          [key]: {
            ...(state.stats[key] || DEFAULT_REQUEST_STATE),
            ...data
          }
        }
      };
    }
    case UPDATE_TIER_LIST_TALENTS_DATA: {
      const { key, data } = action.payload as { key: string; data: Partial<TTierTalentsState> };
      return {
        ...state,
        tierTalents: {
          ...state.tierTalents,
          [key]: { ...(state.tierTalents[key] || DEFAULT_REQUEST_STATE), ...data }
        }
      };
    }
    case UPDATE_TIER_GEAR_DATA: {
      const { key, data } = action.payload as { key: string; data: Partial<TTierGearState> };
      return {
        ...state,
        tierGear: {
          ...state.tierGear,
          [key]: { ...(state.tierGear[key] || DEFAULT_REQUEST_STATE), ...data }
        }
      };
    }
    case UPDATE_TIER_TRINKETS_DATA: {
      const { key, data } = action.payload as { key: string; data: Partial<TTierTrinketsState> };
      return {
        ...state,
        tierTrinkets: {
          ...state.tierTrinkets,
          [key]: { ...(state.tierTrinkets[key] || DEFAULT_REQUEST_STATE), ...data }
        }
      };
    }
    default:
      return state;
  }
}

export const actions = {
  fetchStatisticsData,
  updateStatisticsData,
  fetchStatisticsDataById,
  fetchTierTalentsData,
  updateTierTalentsData,
  fetchTierGearData,
  updateTierGearData,
  fetchTierTrinketsData,
  updateTierTrinketsData
};

export const actionTypes = {
  FETCH_STATISTICS_DATA,
  FETCH_STATISTICS_DATA_BY_ID,
  UPDATE_STATISTICS_DATA,
  FETCH_TIER_LIST_TALENTS_DATA,
  UPDATE_TIER_LIST_TALENTS_DATA,
  FETCH_TIER_GEAR_DATA,
  UPDATE_TIER_GEAR_DATA,
  FETCH_TIER_TRINKETS_DATA,
  UPDATE_TIER_TRINKETS_DATA
};
